<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-menu-unfold`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 36a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h38zM6.19 17.7c.216 0 .428.06.614.172l8.488 5.117a1.19 1.19 0 010 2.037l-8.488 5.117A1.19 1.19 0 015 29.124V18.891c0-.658.532-1.19 1.19-1.19zM43 22a1 1 0 011 1v2a1 1 0 01-1 1H23a1 1 0 01-1-1v-2a1 1 0 011-1h20zm0-14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V9a1 1 0 011-1h38z"/></svg>
</template>
<script>

export default {
  name: 'IconMenuUnfold',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
